"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "offset", {
    enumerable: true,
    get: function() {
        return offset;
    }
});
const _dom = require("@floating-ui/dom");
const _getFloatingUIOffset = require("../utils/getFloatingUIOffset");
function offset(offsetValue) {
    const floatingUIOffset = (0, _getFloatingUIOffset.getFloatingUIOffset)(offsetValue);
    return (0, _dom.offset)(floatingUIOffset);
}
